// Angular
import { Component, Output, Input, EventEmitter, OnInit } from "@angular/core";
// Models
import { Club } from "./../../models/club";
// Services
import { ElasticService } from "./../../services/elastic";
// External
import * as lodash from "lodash";
import { AUTOCOMPLETE_OPTION_HEIGHT } from "@angular/material";

@Component({
  selector: "app-tournament-player",
  templateUrl: "./club-select.component.html",
  styleUrls: ["./club-select.component.scss"],
})
export class TournamentPlayersComponent implements OnInit {
  @Output() onChange: EventEmitter<any>;
  @Input() isPro: boolean;
  @Input() isMain: boolean;
  @Input() team: Array<any>;
  @Input() model: string;
  @Input() ignorePlayers: Array<any>;
  
  public query: string;
  public clubs: Array<any>;
  private typingDelay: any;
  private players: Array<any> = [];
  public error = false;

  constructor(private elasticSearch: ElasticService) {
    this.onChange = new EventEmitter(true);
    this.query = "";
  }
  ngOnInit() {
    if (this.model) {
      this.query = this.model;
    }
  }

  searchMention() {
    if (this.team && this.team.length > 0) {
      this.team.map((x) => {
        if (x.players) {
          Object.keys(x.players).map((y) => {
            let index = this.players.findIndex((z) => z == y);
            if (index == -1) {
              this.players.push(y);
            }
          });
        }
      });
    }

    if (this.isPro) {
      const queryParams1 = {
        index: "users",
        type: "user",
        size: 10,
        "body/query/bool/must/query_string/query": `${this.query}*`,
        "body/query/bool/must/query_string/fields": ["fullName^2", "username"],
        "body/query/bool/should/match/isPro": false,
      };
      this.elasticSearch
        .search(queryParams1)
        .then((result) => {
          this.clubs = [];
          if (result && result["hits"]) {
            lodash.forEach(result["hits"], (item) => {
              if (this.team && this.team.length > 0) {
                let index = this.players.findIndex((x) => x == item["_id"]);
                if (index == -1) {
                  let club = lodash.assign(
                    { $key: item["_id"] },
                    item["_source"]
                  );
                  if (this.ignorePlayers && this.ignorePlayers.length > 0) {
                    let i = this.ignorePlayers.findIndex(
                      (x) => x.id == club.$key
                    );
                    if (i == -1) this.clubs.push(club);
                  } else {
                    this.clubs.push(club);
                  }
                }
              } else {
                let club = lodash.assign(
                  { $key: item["_id"] },
                  item["_source"]
                );
                if (this.ignorePlayers && this.ignorePlayers.length > 0) {
                  let i = this.ignorePlayers.findIndex(
                    (x) => x.id == club.$key
                  );
                  if (i == -1) this.clubs.push(club);
                } else {
                  this.clubs.push(club);
                }
              }
            });
          }
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      const queryParams = {
        index: "users",
        type: "user",
        size: 10,
        "body/query/bool/must/query_string/query": `${this.query}*`,
        "body/query/bool/must/query_string/fields": ["fullName^2", "username"],
        "body/query/bool/should/match/isPro": false,
        "body/query/bool/minimum_should_match": 1,
      };
      this.elasticSearch
        .search(queryParams)
        .then((result) => {
          this.clubs = [];
          lodash.forEach(result["hits"], (item) => {
            if (this.team && this.team.length > 0) {
              let index = this.players.findIndex((x) => x == item["_id"]);
              if (index == -1) {
                let club = lodash.assign(
                  { $key: item["_id"] },
                  item["_source"]
                );
                if (this.ignorePlayers && this.ignorePlayers.length > 0) {
                  let i = this.ignorePlayers.findIndex(
                    (x) => x.id == club.$key
                  );
                  if (i == -1) this.clubs.push(club);
                } else {
                  this.clubs.push(club);
                }
              }
            } else {
              let club = lodash.assign({ $key: item["_id"] }, item["_source"]);
              if (this.ignorePlayers && this.ignorePlayers.length > 0) {
                let i = this.ignorePlayers.findIndex((x) => x.id == club.$key);
                if (i == -1) this.clubs.push(club);
              } else {
                this.clubs.push(club);
              }
            }
          });
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }

  changeQuery() {
    clearTimeout(this.typingDelay);

    this.onChange.emit();

    this.typingDelay = setTimeout(() => {
      this.searchMention();
    }, 400);
  }

  onFocus() {
    this.searchMention();
  }

  onBlur() {
    setTimeout(() => {
      this.clubs = [];
    }, 500);
  }

  chooseClub(club: any) {
    let j = -1;

    loop1: for (j = 0; j < this.team.length; j++) {
      const item1 = this.team[j];

      for (let i = 0; i < Object.keys(item1.playerss).length; i++) {
        const element = Object.keys(item1.playerss)[i];
        if (element === club.$key) {
          break loop1;
        }
      }
    }

    if (j > -1 && j !== this.team.length) {
      this.onChange.emit(null);

      this.query = "This player is already taken";
      this.error = true;
    } else {
      this.error = false;

      this.query = club.fullName;
      club.handicap = club.handicap.toFixed(1);
      this.onChange.emit(club);
    }
    this.clubs = [];
  }
}
